<template>
    <div class="newsinfo">
        <div class="head-box"><navBar :isNav2="true"></navBar></div>
        <!-- 面包屑 -->
        <div class="breadbox">
            <div class="container1">
                <div class="f_cont">
                    <router-link to="/">首页</router-link>
                    <span>&gt;</span>
                    <router-link to="/news">资讯中心</router-link>
                    <span>&gt;</span>
                    <a href="javascript:;">资讯新闻详情</a>
                </div>
            </div>
        </div>
        <div class="newsinfo-sec1 ptb140">
            <div class="container1">
                <div class="cont">
                    <div class="lt" style="width:100%">
                        <div class="fztit font40">
                            {{ form.title }}
                        </div>
                        <div class="jut">
                            <div class="ne">
                                <div class="li">分类：{{ typeObj[form.refColumnId] }}</div>
                                <div class="li">
                                    作者：数位
                                </div>
                                <div class="li">发布时间：{{ form.updateTime }}</div>
                            </div>
                            <!-- <div class="fen">
                <div class="name">
                  <img src="../../assets/images/fenioc1.svg" alt="">
                </div>
                <div class="social-share" data-sites="wechat, weibo"></div>
              </div> -->
                        </div>
                        <div class="make-text" v-html="form.content"></div>
                        <div class="qie">
                            <div class="flt">
                                <!-- <div class="li prev">
                  <span>上一篇：</span>
                  <a href="javascript:;">
                    无
                  </a>
                </div>
                <div class="li next">
                  <span>下一篇：</span>
                  <router-link :to="{name:'Newsinfo',params:{id: '3'}}">
                    「数位」副总裁姜辉：线下大数据的价值正与日俱增
                  </router-link>
                </div> -->
                            </div>
                            <div class="fgt">
                                <a href="javascript:history.back();" class="fblack">
                                    <span>返回列表</span>
                                    <i><img src="../../assets/images/freturnicon1.svg" alt="" /></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="gt">
            <div class="fzitem">
              <div class="ftit font30">
                相关新闻
              </div>
              <div class="jut">
                <router-link :to="{name: Newsinfo,params:{id:2}}" class="item">
                  <div class="tit1 font18">数位成功交付某互联网头部客户线下数据...</div>
                  <div class="text">该客户旗下产品全球活跃用户超过20亿，覆盖全球超过 150 个国家和地区。该客户联合数位完...</div>
                </router-link>
                <router-link :to="{name: Newsinfo,params:{id:2}}" class="item">
                  <div class="tit1 font18">数位成功交付某互联网头部客户线下数据...</div>
                  <div class="text">该客户旗下产品全球活跃用户超过20亿，覆盖全球超过 150 个国家和地区。该客户联合数位完...</div>
                </router-link>
                <router-link :to="{name: Newsinfo,params:{id:2}}" class="item">
                  <div class="tit1 font18">数位成功交付某互联网头部客户线下数据...</div>
                  <div class="text">该客户旗下产品全球活跃用户超过20亿，覆盖全球超过 150 个国家和地区。该客户联合数位完...</div>
                </router-link>
              </div>
            </div>
          </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from '../../components/navBar.vue';
import '../../assets/css/share.min.css';
import '../../assets/js/jquery.share.min.js';
import { newsDetails, getByBusinessId } from '../../api/index';
export default {
    components: {
        navBar
    },
    data() {
        return {
            form: {},
            typeObj: {}
        };
    },
    mounted() {
        this.getTypeList();
        this.getDetails(this.$route.params.id);
    },
    methods: {
        getDetails(id) {
            newsDetails(id).then(res => {
                this.form = res || {};
            });
        },
        getTypeList() {
            let data = { businessId: 1, pagePath: '/industry-solution' };
            getByBusinessId(data).then(res => {
                res.data.map(item => {
                    this.typeObj[item.id] = item.name;
                });
            });
        }
    }
};
</script>

<style scoped lang="less">
::v-deep .navBar-box {
    z-index: 100;
    background: #fff;
    box-shadow: 0 4px 40px rgba(50, 51, 51, 0.06);
    .navbar .nav-link {
        color: #333333;
    }
    .navbar .right-box .el-dropdown-link,
    .navbar {
        color: #333;
    }
    .navbar .nav-link .arrow {
        background-image: url(../../assets/images/arrow-down2.svg);
    }
    .navbar .navbar-toggler .icon-caidan {
        color: #333;
    }
    .navbar .navbar-collapse {
        @media @max-sm {
            position: absolute;
            top: 80px;
            left: 0;
            width: 100%;
            padding: 0 20px;
            background: #fff;
            overflow: hidden;
        }
    }
    .left-box {
        @media @max-sm {
            display: flex;
            align-items: center;
            height: 60px;
        }
    }
}

.head-box {
    box-shadow: 0px 4px 40px 0px rgba(50, 51, 51, 0.06);
}
</style>
